export const HOTEL_SEARCH_QUERY_PARAM_KEYS = {
  checkInDate: 'in',
  checkOutDate: 'out',
  room: 'room',
  slug: 'slug',
};
